<template>
  <div class="stream-tab-body">
    <div class="stream-tab-body-header">
      <div class="analytic-counter-item">
        <div class="analytic-counter-item-label">Total Views</div>
        <div class="analytic-counter-item-value">{{ analytics.total_views }}</div>
      </div>
      <div class="analytic-counter-item">
        <div class="analytic-counter-item-label">Current Viewers</div>
        <div class="analytic-counter-item-value">{{ analytics.current_viewers }}</div>
      </div>
      <div class="analytic-counter-item">
        <div class="analytic-counter-item-label">Total User In chat</div>
        <div class="analytic-counter-item-value">{{ analytics.total_user_in_chat }}</div>
      </div>
    </div>
    <div class="stream-tab-body-body">
      <div class="stream-tab-body-body-header">
        Concurrent viewers
      </div>
      <div class="stream-tab-body-body-chart-widget">
        <apexchart type="area" ref="analiticsChart" height="400px" width="100%" :options="chartOptions"
          :series="series">
        </apexchart>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    event: {
      type: Object,
      required: true,
      return() {
        return null;
      }
    },
  },
  data: () => ({
    series: [
      {
        name: "",
        data: [],
        color: "#000000",
      },
    ],
    chartOptions: {
      chart: {
        type: "area",
        height: 400,
        zoom: {
          enabled: false
        },
        toolbar: {
          show: false,
        }
      },
      plotOptions: {

      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          text: "Views",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "Views: " + val;
          },
        },
      },
    },
    get_analytics_timer: null,
    analytics: {
      total_views: 0,
      current_viewers: 0,
      total_user_in_chat: 0,
    },
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getStreamAnalytics();
    vm.get_analytics_timer = setInterval(() => {
      vm.getStreamAnalytics();
    }, 1000 * 2);
  },
  beforeDestroy() {
    let vm = this;
    clearInterval(vm.get_analytics_timer);
  },
  methods: {
    getStreamAnalytics() {
      let vm = this;
      vm.$store.dispatch("STREAMING_GET_STREAM_ANALYTICS", {
        event_id: vm.event.id
      }).then((response) => {
        const result = response.data.return;
        vm.analytics.total_views = result.total_views;
        vm.analytics.current_viewers = result.current_views;
        vm.analytics.total_user_in_chat = result.total_user_inchat;
        const concurrent_viewers = result.concurrent_viewers.reverse();
        const seriesData = concurrent_viewers.map((item) => item.count);
        const categories = concurrent_viewers.map((item) => vm.moment(item.time).format("hh:mm A"));
        vm.$refs.analiticsChart.updateOptions({
          xaxis: {
            categories: categories,
          },
        });
        vm.series = [
          {
            name: "",
            data: seriesData,
            color: "#000000",
          },
        ];

      }).catch((error) => {
        console.log(error);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.stream-tab-body {
  height: calc(100% - 400px);
  width: 100%;
  display: flex;
  flex-direction: column;

  .stream-tab-body-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 20px;
    border-bottom: 1px solid #ddd;
    height: 65px;

    .analytic-counter-item {
      display: flex;
      flex-direction: column;

      .analytic-counter-item-label {
        font-size: 12px;
        color: #666;
      }

      .analytic-counter-item-value {
        font-size: 20px;
        color: #333;
      }
    }
  }

  .stream-tab-body-body {
    height: calc(100% - 65px);
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .stream-tab-body-body-header {
      font-size: 16px;
      padding: 10px 20px;
      color: #333;
    }
  }
}
</style>